import { Globe } from "@ews-admin/global-design-system";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { RootState } from "../../../store/store";
import { updateAppLanguage } from "../../../webclients/user.client";

const languages = [
  { code: "en", name: "English" },
  { code: "fr", name: "Français" },
];

export const LanguageSwitcher: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
  const userId = useSelector(
    (state: RootState) => state.session.session?.user?.id
  );

  // Update current language when i18n language changes
  useEffect(() => {
    setCurrentLanguage(i18n.language);
  }, [i18n.language]);

  const toggleLanguage = async () => {
    const nextLanguage = currentLanguage === "en" ? "fr" : "en";
    try {
      await i18n.changeLanguage(nextLanguage);
      localStorage.setItem("language", nextLanguage);
      setCurrentLanguage(nextLanguage);
      // Persist for emails sent without a request (reminders, doctor copies).
      // Fire-and-forget: a failure here must not block the UI switch.
      if (userId) {
        updateAppLanguage(userId, nextLanguage).catch(() => undefined);
      }
    } catch (error) {
      console.error("Error changing language:", error);
    }
  };

  const currentLanguageName =
    languages.find((lang) => lang.code === currentLanguage)?.name || "Language";

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center px-3 py-2 space-x-3 w-full text-sm rounded-lg transition-colors text-neutral-700 hover:bg-neutral-50 hover:text-neutral-900"
      title={t(currentLanguage === "en" ? "common.switchToFrench" : "common.switchToEnglish")}
    >
      <Globe className="w-5 h-5 text-neutral-500" />
      <span>{currentLanguageName}</span>
    </button>
  );
};
